import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConcurrentRequestHandlingService } from '@modules/common/services/concurrent-request-handling.service';
import { ApiProxyOptions } from '@modules/common/models/api-proxy-options';
import { GetParticipantDocumentURLArgs } from './get-participant-document-url-args.generated';
import { GetParticipantDocumentURLResult } from './get-participant-document-url-result.generated';

@Injectable({
    providedIn: 'root'
})
export class GetParticipantDocumentURLService {
    constructor(private _concurrentRequestHandlingService: ConcurrentRequestHandlingService) { }

    public getParticipantDocumentURL(args: GetParticipantDocumentURLArgs, options?: ApiProxyOptions): Observable<GetParticipantDocumentURLResult> {
        return this._concurrentRequestHandlingService.callApi<GetParticipantDocumentURLResult>(
            "GetParticipantDocumentURLService_getParticipantDocumentURL",
            {
                url: '/Participant/GetParticipantDocumentURL/GetParticipantDocumentURL',
                body: typeof args === 'undefined' || args === null ? {} : args,
                sendCredentials: true
            }, options
        );
    }
}
